// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.min.css';
// import AppRouter from './routes';
// import { HelmetProvider } from 'react-helmet-async';

// function App() {
//   return (
//     <HelmetProvider>
//       <AppRouter />
//     </HelmetProvider>
//   );
// }

// export default App;

import FrontPage from "./pages/FrontPage";
import PrivacyPolicy from "./pages/PrivatePolicy";
import TermsConditions from "./pages/TermsConditions";
import SafetyTips from "./pages/SafetyTips";
import CookiePolicy from "./pages/CookiePolicy";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/revamp/Navbar";
import DownloadLink from "./pages/download-link";
import { lazy, Suspense } from "react";
import Spinner from "./components/atoms/Spinner";

function App() {
  const Loadable = (Component) => (props) =>
    (
      <Suspense fallback={<Spinner isLoading={true} text=" " size="lg" />}>
        <Component {...props} />
      </Suspense>
    );

  const ReadsListPage = Loadable(lazy(() => import("./pages/reads/list")));

  const ViewReadPage = Loadable(lazy(() => import("./pages/reads/view")));

  const DeleteAccountPage = Loadable(
    lazy(() => import("./pages/delete-account"))
  );

  // const InquiriesPage = Loadable(lazy(() => import("./pages/inquiries")));

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navbar />}>
            {/* <Route exact path="/private/inquiries" element={<InquiriesPage />} /> */}
            <Route index element={<FrontPage />} />
            <Route path="/privacy/policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-condition" element={<TermsConditions />} />
            <Route path="/community/safety-tips" element={<SafetyTips />} />
            <Route path="/privacy/cookie-policy" element={<CookiePolicy />} />
            <Route
              path="/community/guidelines"
              element={<CommunityGuidelines />}
            />
            <Route path="/download-link" element={<DownloadLink />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
          </Route>

          <Route path="reads">
            <Route path="list" element={<ReadsListPage />} />
            <Route path="list/:id" element={<ViewReadPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
